import { Card, Typography, Divider, CardContent, Grid, Link } from '@mui/material';

import {useState, useEffect} from 'react';

import {useAuth} from "../../contexts/AuthContext"

import {getLocations} from "../Utils"

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import { useHistory } from 'react-router-dom';
import { formatPrice } from './OrderUtils';

const db = app.firestore();
const storage = app.storage();

const freqFr={
  'unique': 'Unique',
  'weekly': 'Hébdomadaire',
  'monthly': 'Mensuelle'
}

function SummaryItem({title, value, link}) {
  return (
    <CardContent sx={{py: 3}}>
      {/* <Typography>Test</Typography> */}
      <Grid container spacing={4} wrap="wrap">
        <Grid item xs={4} >
          <Typography color="textPrimary" variant="subtitle1">
            {title}
          </Typography>
        </Grid>
        <Grid item xs={8} >
          {
            link ? (
              <Link href={link}>
                {value}
              </Link>
            ) : (
              <Typography>
                {value}
              </Typography>
            ) 
          }
        </Grid>
      </Grid>   
    </CardContent>
  );
}

export default function OrderCard({isUpdate, orderId, setLastRefreshDate, ...rest}) {
  const history = useHistory()

  const [locationIndex, setLocationIndex] = useState("-1");
  const [locations, setLocations] = useState([]);

  const [cachedOrder, setCachedOrder] = useState(null);
  const [deliveryNoteUrl, setDeliveryNoteUrl] = useState("");

  const {retailerId, retailerFallbackLocationId} = useAuth();

  useEffect( () => {
    const loadAndSetOrder = async () => {
      if(!orderId) {
        return;
      }    

      const orderRef = await db.collection('carts').doc(orderId).get();
      const order = orderRef.data();

      if(order.retailerId !== retailerId) {
        history.push("/orders");
      }

      setCachedOrder(order);
    }

    loadAndSetOrder();

  }, [orderId])

  useEffect( () => {
    const loadAndSetLocations = async () => {
      try {
        const newLocations = (await getLocations(retailerId, true))
          .map((loc, idx) => ({
            value: "" + idx,
            label: loc.address,
            id: loc.id,
            location: loc.data
          }));
        
        newLocations.push({value: "" + newLocations.length, label: "Autre addresse", id:""});
        setLocationIndex("-1");
        setLocations(newLocations);
      } catch(e) {
        console.log("error while loading locations");
        console.log(e.message);
        setLocations([]);
      }
    }

    loadAndSetLocations();
    
  }, [retailerId]);

  useEffect( () => {
    const loadAndSetDeliveryNoteUrl = async () => {
      if(cachedOrder && locations.length > 0) {
        const locationId = cachedOrder.locationId !== undefined ? cachedOrder.locationId : retailerFallbackLocationId;
        for(let loc of locations) {
          if(loc.id === locationId) {
            setLocationIndex(loc.value);
            break;
          }
        }

        if (cachedOrder.deliveryNotePath) {
          const path = cachedOrder.deliveryNotePath;
          const ref = storage.ref(path);
          let url = "";
          try {
            url = await ref.getDownloadURL();
          } catch(e) {
            console.log("error while getting download url");
            console.log(e.message);          
          }
          setDeliveryNoteUrl(url);
        }
      }
    }

    loadAndSetDeliveryNoteUrl();

  }, [cachedOrder, locations])

  if (!cachedOrder) {
    console.log("error loading the order");
    return null;
  }

  let pickupAddressSummary = null;
  
  const pickupAddress = cachedOrder.pickupAddress;
  if (pickupAddress) {
    pickupAddressSummary = pickupAddress.address1 + ", " + pickupAddress.postcode + " " + pickupAddress.city;
  } else {
    pickupAddressSummary = (locations && locations.length > 0 && locationIndex !== "-1" ? locations[parseInt(locationIndex)].label : "");
  }

  const customer = cachedOrder.customerAddress;

  const destAddressSummary = customer.address1 + ", " + customer.postcode + " " + customer.city;

  const destNameSummary = customer.firstName + (customer.lastName ? " " + customer.lastName : "");

  const destCompany = customer.company ? customer.company : "";

  let tsSummary = cachedOrder.timeSlotString;

  let deliveredTo = cachedOrder.deliveredTo;

  if(!tsSummary && cachedOrder.timeSlot) {
    const startHour = cachedOrder.timeSlot.toDate().getHours();
    const endHour = startHour + (cachedOrder.timeSlotDuration ? parseInt(cachedOrder.timeSlotDuration) : 1); 
    tsSummary = cachedOrder.timeSlot.toDate().toLocaleDateString() + ", " + startHour + "h - " + endHour +"h";
  }

  const frequency = cachedOrder.frequency ? cachedOrder.frequency : "unique";

  const price = cachedOrder.shippingPrice !== undefined ? formatPrice(cachedOrder.shippingPrice) : '-.--';

  return (
    <>      
      <form>
        <Card>
          <SummaryItem title="Référence" value={cachedOrder.name}/>
          <Divider />
          <SummaryItem title="Poids" value={cachedOrder.weight ? cachedOrder.weight + " kg" : ""}/>
          <Divider />
          <SummaryItem title="Addresse de collecte" value={pickupAddressSummary}/>
          <Divider />
          <SummaryItem title="Addresse du destinataire" value={destAddressSummary}/>
          <Divider />
          <SummaryItem title="Nom du destinataire" value={destNameSummary}/>
          <Divider />
          <SummaryItem title="Entreprise du destinataire" value={destCompany}/>
          <Divider />
          <SummaryItem title="Téléphone du destinataire" value={cachedOrder.phoneNumber}/>          
          <Divider />          
          <SummaryItem title="Créneau horaire" value={tsSummary}/>
          <Divider />
          <SummaryItem title="Fréquence" value={freqFr[frequency]}/>
          <Divider />
          { 
            deliveryNoteUrl ? 
              <>
                <SummaryItem title="Bon de livraison" value={cachedOrder.deliveryNotePath} link={deliveryNoteUrl}/>
                <Divider />
              </> :
              <>
              </>
          }
          { 
            deliveredTo ? 
              <>
                <SummaryItem title="Livré à" value={deliveredTo}/>          
                <Divider />
              </> :
              <>
              </>
          }          
          <SummaryItem title="Prix" value={price}/>
        </Card>
      </form>
    </>
  );
}

